import { CustomerSelectorComponent } from "./component";
import { useAdmin, useApi } from "../../../contexts/app/provider";

export const CustomerSelectorContainer = () => {
  const { allCustomers } = useAdmin();
  const { selectedCustomerId, setSelectedCustomerId } = useApi();

  return (
    <CustomerSelectorComponent
      onSelect={setSelectedCustomerId}
      allCustomers={allCustomers || []}
      selectedCustomerId={selectedCustomerId}
    />
  );
};
